(function (window, document) {
  if (window.Playerjs) return;

  const formatTime = (seconds) => {
    if (!isFinite(seconds)) return "0:00";
    const minutes = Math.floor(seconds / 60) || 0;
    const secs = Math.floor(seconds % 60) || 0;
    return `${minutes}:${secs.toString().padStart(2, "0")}`;
  };

  class PlayerjsPlayer {
    constructor(section) {
      this.section = section;
      this.container = section.querySelector(".video-section-video");
      if (!this.container) return;
      this.video = this.container.querySelector("video");
      if (!this.video) return;
      this.overlay = this.container.querySelector(".video-section-play-button");
      this.video.controls = false;
      this.video.removeAttribute("controls");
      this.ready = false;
      this.buildControls();
      this.bindEvents();
      this.updateDuration();
      this.updateProgress();
      this.ready = true;
    }

    buildControls() {
      this.controls = document.createElement("div");
      this.controls.className = "playerjs-controls";
      this.controls.setAttribute("inert", "");

      this.playToggle = document.createElement("button");
      this.playToggle.type = "button";
      this.playToggle.className = "playerjs-button";
      this.playToggle.setAttribute("aria-label", "Play video");
      this.playToggle.innerHTML =
        '<span class="playerjs-button-icon" aria-hidden="true"></span>';

      const progressWrap = document.createElement("div");
      progressWrap.className = "playerjs-progress";

      this.progress = document.createElement("input");
      this.progress.type = "range";
      this.progress.min = "0";
      this.progress.max = "1000";
      this.progress.value = "0";
      this.progress.setAttribute("aria-label", "Seek video");

      this.timeLabel = document.createElement("span");
      this.timeLabel.className = "playerjs-time";
      this.timeLabel.textContent = "0:00 / 0:00";

      progressWrap.appendChild(this.progress);

      this.controls.appendChild(this.playToggle);
      this.controls.appendChild(progressWrap);
      this.controls.appendChild(this.timeLabel);
      this.container.appendChild(this.controls);
    }

    bindEvents() {
      if (this.overlay) {
        this.overlay.addEventListener("click", () => this.play());
      }

      this.playToggle.addEventListener("click", () => this.toggle());

      this.video.addEventListener("play", () => this.setPlaying(true));
      this.video.addEventListener("pause", () => this.setPlaying(false));

      this.video.addEventListener("timeupdate", () => this.updateProgress());
      this.video.addEventListener("loadedmetadata", () =>
        this.updateDuration()
      );
      this.video.addEventListener("ended", () => {
        this.setPlaying(false);
        this.updateProgress();
      });

      this.progress.addEventListener("input", (event) => {
        if (!isFinite(this.video.duration) || this.video.duration <= 0) return;
        const ratio = Number(event.target.value) / 1000;
        this.video.currentTime = this.video.duration * ratio;
      });
    }

    setPlaying(isPlaying) {
      this.section.classList.toggle("video-playing", isPlaying);
      if (this.controls) {
        this.controls.style.opacity = isPlaying ? "1" : "0";
        this.controls.style.pointerEvents = isPlaying ? "auto" : "none";
        if (isPlaying) {
          this.controls.removeAttribute("inert");
        } else {
          this.controls.setAttribute("inert", "");
        }
      }
      if (this.overlay) {
        this.overlay.style.display = isPlaying ? "none" : "block";
        this.overlay.setAttribute(
          "aria-label",
          isPlaying ? "Pause video" : "Play video"
        );
      }
      this.playToggle.setAttribute(
        "aria-label",
        isPlaying ? "Pause video" : "Play video"
      );
      this.playToggle.classList.toggle("is-playing", isPlaying);
    }

    updateDuration() {
      if (!isFinite(this.video.duration)) return;
      this.timeLabel.textContent = `${formatTime(
        this.video.currentTime
      )} / ${formatTime(this.video.duration)}`;
    }

    updateProgress() {
      if (!isFinite(this.video.duration) || this.video.duration <= 0) return;
      const ratio = this.video.currentTime / this.video.duration;
      this.progress.value = Math.min(1000, Math.max(0, ratio * 1000));
      this.timeLabel.textContent = `${formatTime(
        this.video.currentTime
      )} / ${formatTime(this.video.duration)}`;
    }

    play() {
      this.video.play().catch(() => {});
    }

    pause() {
      this.video.pause();
    }

    toggle() {
      if (this.video.paused) this.play();
      else this.pause();
    }

    pauseIfOutOfView() {
      if (this.video.paused) return;
      const rect = this.section.getBoundingClientRect();
      const viewportHeight =
        window.innerHeight || document.documentElement.clientHeight;
      const visible =
        rect.top < viewportHeight * 0.75 && rect.bottom > viewportHeight * 0.25;
      if (!visible) {
        this.pause();
      }
    }
  }

  const Playerjs = {
    createAll(selector = ".video-section") {
      const nodes =
        typeof selector === "string"
          ? document.querySelectorAll(selector)
          : selector;
      return Array.from(nodes)
        .map((node) => new PlayerjsPlayer(node))
        .filter((player) => player.ready);
    },
  };

  window.Playerjs = Playerjs;
})(window, document);
